"use client";

import { createContext, type PropsWithChildren, useContext } from "react";

const AnalyticsCaptureReadyContext = createContext(false);

export function AnalyticsCaptureReadyProvider({
	ready,
	children,
}: PropsWithChildren<{ ready: boolean }>) {
	return (
		<AnalyticsCaptureReadyContext.Provider value={ready}>
			{children}
		</AnalyticsCaptureReadyContext.Provider>
	);
}

export function useAnalyticsCaptureReady(): boolean {
	return useContext(AnalyticsCaptureReadyContext);
}
